import React, {useContext, useRef, useState} from "react"
import RefreshTimer from "../../../util/RefreshTimer";
import Row from "@meridian/components/row";
import Column from "@amzn/meridian/column";
import {injectIntl} from "react-intl";
import Button from "@amzn/meridian/button";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Icon from "@amzn/meridian/icon";
import Box from "@amzn/meridian/box";
import Tooltip from "@amzn/meridian/tooltip";
import chevronDownLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-down-large";
import {LidarOverviewContext} from "../context/LidarOverviewContext";
import Expander from "@amzn/meridian/expander"
import Modal from "@amzn/meridian/modal";

const LidarConfigurationModal = (props) => {

    const {viewModel} = useContext(LidarOverviewContext);
    const {open, setOpen, selected, setSelected} = props;
    const [expanded, setExpanded] = useState(new Set([]));
    const tableEndRef = useRef(null);
    const {formatMessage} = props.intl;

    const expand = (expanderName) => {
        const newExpanded = new Set(expanded);
        if (newExpanded.has(expanderName)) {
            newExpanded.delete(expanderName);
        } else {
            newExpanded.add(expanderName);
        }
        setExpanded(newExpanded);
    };
    const isExpanded = (expanderName) => {
        return expanded.has(expanderName);
    };

    const getColumnLabels = (assetMapping) => {
        return assetMapping.columns && assetMapping.columns.reduce((columnLabels, column) => {
            columnLabels.push(getDisplayableColumnLabel(column.columnLabel))
            return columnLabels;
        }, []);
    }

    const getDisplayableColumnLabel = (columnLabel) => {
        return /[A-Z]+$/.exec(columnLabel);
    }

    const device = open ? viewModel.lidarDeviceInformation[selected] : null;

    const scrollToBottom = () => {
        tableEndRef.current.scrollIntoView({behavior: "smooth"})
    }

    const getLidarControllerExpanderTitle = (device) => {
        return "Controller:" + device.mac + "\u2003 \u2003 \u2003 Aisle:" + device.startAisleLabel + "-" + device.endAisleLabel + "(total " + device.aislesCount
            + ")";
    }

    const onCloseModal = () => {
        setOpen(false)
        setSelected(null);
    }

    const getAisleExpanderTitle = (assetMapping) => {
        return  assetMapping.aisleLabel + "\u2003 \u2003 \u2003" + getColumnLabels(assetMapping);
    }

    if (open) {
        return (
            <Modal
                title={formatMessage({id: "device.configuration"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium"
                width="100%">
                <Row widths="100%"
                     alignmentVertical="top"
                     spacingInset="none none large none">
                    <Column>
                        <Row width="100%" widths={["100", "fill", "100"]}>
                            <RefreshTimer deps={[viewModel]}/>
                            <Box></Box>
                            <Tooltip position="top" title={formatMessage({
                                id: 'tooltip.scrolltobottom',
                                defaultMessage: 'Scroll to bottom!'
                            })}>
                                <Button onClick={scrollToBottom}
                                        type="secondary"
                                        size="small">
                                    <Icon tokens={chevronDownLargeTokens}/>
                                </Button>
                            </Tooltip>
                        </Row>
                        <Expander open={isExpanded(device.mac)} onChange={() => expand(device.mac)}
                                  title={getLidarControllerExpanderTitle(device)} type="box">
                            <br/>
                            {device.displayableAssetMappings.map((assetMapping) => (
                                <Expander open={isExpanded(assetMapping.aisleLabel)}
                                          onChange={() => expand(assetMapping.aisleLabel)}
                                          title={getAisleExpanderTitle(assetMapping)} type="box">
                                    <br/>
                                    <Table headerRows={1}
                                           spacing="small"
                                           showDividers={true}
                                           showStripes={true}>
                                        <TableRow highlightOnHover={false}>
                                            <TableCell>
                                                Column
                                            </TableCell>
                                            <TableCell>
                                                Column Type
                                            </TableCell>
                                        </TableRow>
                                        {assetMapping.columns.map((column) => (
                                            <TableRow>
                                                <TableCell>
                                                    {getDisplayableColumnLabel(column.columnLabel)}
                                                </TableCell>
                                                <TableCell>
                                                    {viewModel.cartRecipesMap.has(column.cartType) && viewModel.cartRecipesMap.get(column.cartType).displayName ?
                                                        viewModel.cartRecipesMap.get(column.cartType).displayName : column.cartType}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </Table>
                                </Expander>
                            ))}
                        </Expander>
                        <div ref={tableEndRef}/>
                    </Column>
                </Row>
            </Modal>
        )
    } else {
        return null;
    }
}
export default injectIntl(LidarConfigurationModal)



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/modal/LidarConfigurationModal.js